<template>
  <master-layout id="whatsNext" ref="whatsNext">
    <div class="flex flex-col min-h-screen">
      <div class="flex-grow">
        <div
          class="w-[100vw] flex flex-row justify-center px-6 lg:px-0 pb-[64px] md:pb-[104px] pt-[40px]"
        >
          <div class="max-w-[856px]">
            <div>
              <h1 class="font-aktiv-grotesk-medium text-[32px] leading-[40px]">
                What's Next
              </h1>
            </div>

            <div
              class="font-aktiv-grotesk-medium text-[16px] leading-[24px] text-lightblue mt-[16px] border-[2px] rounded-[16px] border-lightblue"
            >
              <h1
                class="font-aktiv-grotesk font-bold text-grey-90 text-[20px] mt-[20px] ml-[24px]"
              >
                Quick links:
              </h1>

              <div
                class="flex items-start cursor-pointer mt-[10px] mx-[24px]"
                @click="scrollToGPC"
              >
                <p class="underline text-underline-link relative">
                  Join the GenerationS Pastors Conference
                  <span class="relative">
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <img
                      src="../../public/assets/images/singaporeFlag.png"
                      alt="singaporeFlag"
                      class="absolute top-0 left-0 w-[18px]"
                  /></span>
                  in July 2026
                </p>
              </div>

              <div
                class="flex items-start cursor-pointer mt-[10px] mx-[24px] mb-[24px]"
                @click="scrollToUniCon"
              >
                <p class="underline text-underline-link">
                  Send your young people for the GenerationS University
                  Conference in Singapore
                  <span class="relative">
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <img
                      src="../../public/assets/images/singaporeFlag.png"
                      alt="singaporeFlag"
                      class="absolute top-0 left-0 w-[18px]"
                  /></span>
                </p>
              </div>
            </div>

            <hr class="mt-[32px] md:mt-[40px] border-t border-black" />

            <div>
              <h2
                id="gpc-1"
                ref="gpc-1"
                class="mt-[32px] md:mt-[40px] mb-[16px] font-aktiv-grotesk-medium font-bold text-[28px] leading-[33.6px]"
              >
                <img
                  src="../../public/assets/images/singaporeFlag.png"
                  alt="singaporeFlag"
                  class="inline w-[28px]"
                />
                GenerationS Pastors Conference
              </h2>
              <p class="text-[20px] leading-[28px]">
                Build a StronG church - leave with a picture of what's possible.
              </p>
              <div
                v-if="!hasSignup"
                data-event-tracking="whats-next-gensconf2026-register-now"
                class="pt-[16px]"
                @click="goToGpcForms"
              >
                <BaseImageWrapper
                  src="/assets/images/gpc-2026-register-now-mobile-4.jpg"
                  width="768"
                  class="cursor-pointer md:hidden w-full rounded-[24px] shadow-lg"
                />
                <BaseImageWrapper
                  src="/assets/images/gpc-2026-register-now-desktop-4.jpg"
                  width="1440"
                  class="cursor-pointer hidden md:block rounded-[24px] shadow-lg"
                />
              </div>
              <div
                v-if="hasSignup"
                data-event-tracking="whats-next-gensconf2026-register-now-after-submission"
                class="pt-[16px]"
                @click="goToGpcPage"
              >
                <BaseImageWrapper
                  src="/assets/images/gpc-2026-after-submission-mobile.jpg"
                  width="768"
                  class="cursor-pointer md:hidden w-full rounded-[24px] shadow-lg"
                />
                <BaseImageWrapper
                  src="/assets/images/gpc-2026-after-submission-desktop.jpg"
                  width="1440"
                  class="cursor-pointer hidden md:block rounded-[24px] shadow-lg"
                />
              </div>
            </div>

            <div>
              <h2
                id="unicon"
                ref="unicon"
                class="mt-[32px] md:mt-[40px] mb-[16px] font-aktiv-grotesk-medium font-bold text-[28px] leading-[33.6px]"
              >
                <img
                  src="../../public/assets/images/singaporeFlag.png"
                  alt="singaporeFlag"
                  class="inline w-[28px]"
                />
                GenerationS University Conference
              </h2>
              <p class="text-[20px] leading-[28px]">
                For university students (18-25 years old) who want to build a
                StronG church together with their pastors.
              </p>
              <div
                data-event-tracking="whats-next-zoom-check-in-unicon"
                class="pt-[16px]"
                @click="goToUniConPage"
              >
                <BaseImageWrapper
                  src="/assets/images/unicon-2026-register-now-mobile-2.jpg"
                  width="768"
                  class="cursor-pointer md:hidden w-full rounded-[24px] shadow-lg"
                />
                <BaseImageWrapper
                  src="/assets/images/unicon-2026-register-now-desktop-2.jpg"
                  width="1440"
                  class="cursor-pointer hidden md:block rounded-[24px] shadow-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </master-layout>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import Footer from "@/components/common/Footer.vue";
import BaseImageWrapper from "@/components/common/BaseImageWrapper.vue";

export default {
  components: {
    Footer,
    BaseImageWrapper,
  },
  data() {
    return {
      isTripLeader: false,
      tripLeader: "",
    };
  },
  async ionViewDidEnter() {
    // await this.getTripLeaderStatus();
    await this.$store.dispatch("conference/fetchFormsSignup", 5);
    setTimeout(() => {
      this.scrollViaHash();
    }, 100); // Small delay to ensure DOM is ready
    window.addEventListener("hashchange", this.scrollViaHash);
  },
  ionViewWillLeave() {
    window.removeEventListener("hashchange", this.scrollViaHash);
  },
  computed: {
    ...mapState("conference", ["formsSignup"]),
    hasSignup() {
      return this.formsSignup && this.formsSignup[5];
    },
  },
  methods: {
    goToSignUp() {
      this.$router.push("/forms/gic-signup");
    },
    goToGpcRegisterInterest() {
      window.open(
        "https://generationsmvmt.com/conference/generations-pastors-conference-2026",
        "_blank"
      );
    },
    goToGpcForms() {
      this.$router.push("/forms/gpc-signup");
    },
    goToGpcPage() {
      window.open(
        "https://generationsmvmt.com/conference/generations-pastors-conference",
        "_blank"
      );
    },
    goToUniConPage() {
      window.open(
        "https://generationsmvmt.com/conference/generations-uni-conference/?utm_campaign=uni26&utm_medium=gic-portal&utm_source=whats-next&utm_content=register-banner",
        "_blank"
      );
    },
    goToZoomPage() {
      this.$router.push("/forms/gic-zoom-check-in");
    },

    async getTripLeaderStatus() {
      try {
        // Retrieve the access token from your store or authentication service
        const accessToken = this.$store.state.user.token;

        // Make the API call to check the signup status
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/conference/conference-details/${process.env.VUE_APP_CONFERENCE_ID}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        this.isTripLeader = response.data.isPersonOfContact;
        this.tripLeader = response.data.tripLeader;
      } catch (error) {
        console.error("Error fetching signup status:", error);
      }
    },
    scrollToZoom() {
      const toElement = this.$refs["zoom"];
      const elem = document.getElementById("whatsNext");
      console.log(toElement.offsetTop);
      elem.scrollToPoint(0, toElement.offsetTop - 98, 1000);
    },
    scrollToGPC() {
      const toElement = this.$refs["gpc-1"];
      const elem = document.getElementById("whatsNext");
      console.log(toElement.offsetTop);
      elem.scrollToPoint(0, toElement.offsetTop - 98, 1000);
    },
    scrollToUniCon() {
      const toElement = this.$refs["unicon"];
      const elem = document.getElementById("whatsNext");
      console.log(toElement.offsetTop);
      elem.scrollToPoint(0, toElement.offsetTop - 98, 1000);
    },
    scrollViaHash() {
      const hash = window.location.hash || this.$route.hash; // Get hash from URL

      if (hash) {
        if (hash === "#gpc") {
          this.scrollToGPC();
        } else if (hash === "#zoom-check-in") {
          this.scrollToZoom();
        } else if (hash === "#uni") {
          this.scrollToUniCon();
        }
      }
    },
  },
};
</script>
